export default () => {
	const popup = document.querySelector('.popup-login');
	const CLASS_VISIBLE = 'popup-login--visible';
	const closeBnts = document.querySelectorAll('.js-close-popup');
	const openBnts = document.querySelectorAll('.js-open-login');

	closeBnts.forEach(function(btn) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			
			if (popup) {
				popup.classList.remove(CLASS_VISIBLE);
			}
		});
	});

	openBnts.forEach(function(btn) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			if (popup) {
				popup.classList.add(CLASS_VISIBLE);
			}
		});
	});
}